module.exports = {"items":[{"value":"Law Enforcement","title":"Law Enforcement"},{"value":"Child Protective Services","title":"Child Protective Services"},{"value":"Child Advocacy Center","title":"Child Advocacy Center"},{"value":"Advocate/Case Management","title":"Advocate/Case Management"},{"value":"Housing","title":"Housing"},{"value":"Medical","title":"Medical"},{"value":"General","title":"General"}]}


//////////////////
// WEBPACK FOOTER
// ./src/store/data/noteTypes.json
// module id = 1957
// module chunks = 0